@if (user?.isSuperAdmin || user?.isMultiUser) {
  <p-select
    dataKey="id"
    optionLabel="name"
    appendTo="body"
    placeholder="Select a Company"
    [options]="companies$ | async"
    [virtualScroll]="true"
    [virtualScrollItemSize]="40"
    [filter]="true"
    [filterBy]="filterBy"
    (onFilter)="search($event.filter)"
    (onChange)="setActiveCompany($event)"
    [(ngModel)]="selectedCompany"
  >
    <ng-template #footer>
      @if (capped()) {
        <div class="px-3 py-2 text-sm text-muted-color">
          Showing the first {{ maxResults }}. Type to narrow the list.
        </div>
      }
    </ng-template>
  </p-select>
}
